// Inspired By: https://github.com/stimulus-components/stimulus-dropdown/blob/master/src/index.ts
import UIPopover from "./popover_controller";

export default class extends UIPopover {}
